import './App.css';

function App() {
  return (
    <div className="hero">
      <div className="text-box">
        <h1>
          <span className='welcome-text'>Welcome to</span>
          <br/>
          Felon Books
        </h1>
        <p>tag line here</p>
      </div>
    </div>
  );
}

export default App;